<template>
  <div
    v-if="!isShowContainer"
    :class="[
      'vmp-player',
      {
        'is-watch': isWatch,
        'vmp-player-embed': isEmbedVideo,
        'vmp-player-embedFull': isEmbed && !isEmbedVideo,
        'is-hide-right-menu': isHideRightMenu
      },
      isSubscribe ? '' : `vmp-player--${displayMode}`
    ]"
    :style="{ background: mainBackground }"
    @mousemove="wrapEnter"
    @mouseleave="wrapLeave"
  >
    <OnlineHot v-show="isPlaying && hoveVideo && isEmbedVideo" />
    <VmpOrderRank v-if="showOrderRank"></VmpOrderRank>
    <div
      :id="
        warmUpVideoList.length < 2 ? 'vmp-player' : `vmp-player-vod_${warmUpVideoList[initIndex]}`
      "
      class="vmp-player-watch"
      ref="playerWatch"
    >
      <template class="vmp-player-living">
        <!-- 背景图片 -->
        <div
          v-if="isShowPoster"
          class="vmp-player-living-background"
          v-parseImgOss="{ type: 'bg', url: webinarsBgImg }"
          :style="{ backgroundImage: `url(${webinarsBgImg})` }"
        ></div>
        <!-- 暖场视频播放按钮 -->
        <div
          v-if="initSuccess && isEmbed && isSubscribe && isWarnPreview && !isPlaying"
          class="vmp-player-living-play"
        >
          <div class="vmp-player-living-play-normal" @click="startPlay">
            <i class="vh-iconfont vh-line-video-play"></i>
          </div>
        </div>
        <!-- 直播、回放播放按钮 -->
        <template v-else>
          <div
            class="vmp-player-living-btn"
            v-if="initSuccess && !isPlaying && !isVodEnd && !isDelaying"
          >
            <div
              :class="
                displayMode == 'mini'
                  ? 'vmp-player-living-btn-mini'
                  : 'vmp-player-living-btn-normal'
              "
              @click="startPlay"
            >
              <i class="vh-iconfont vh-line-video-play"></i>
            </div>
          </div>
        </template>

        <div class="vmp-player-living-vodend" v-if="isVodEnd && !isPlaying">
          <div class="vmp-player-living-vodend-try" v-if="isTryPreview">
            <h3>{{ $t('appointment.appointment_1013') }}</h3>
            <div>
              <p v-if="authText == 6">
                <span @click="authTryWatch(3)">
                  {{ $t('appointment.appointment_1010') }}
                </span>
                {{ $t('interact.interact_1020') }}
                <span style="margin-left: 10px" @click="authTryWatch(4)">
                  {{ $t('appointment.appointment_1011') }}
                </span>
              </p>
              <span v-else @click="authTryWatch">{{ authText }}</span>
            </div>
            <p class="replay-try" @click="replayPlay">
              <i class="vh-iconfont vh-line-refresh-left">
                {{ $t('appointment.appointment_1014') }}
              </i>
            </p>
          </div>
          <div class="vmp-player-living-vodend-isNoTry" v-else>
            <div
              :class="[
                displayMode == 'mini'
                  ? 'vmp-player-living-vodend-mini'
                  : 'vmp-player-living-vodend-normal ',
                'vmp-player-living-vodend-isNoTry-refresh'
              ]"
              @click="replayPlay"
            >
              <i class="vh-iconfont vh-line-refresh-left"></i>
            </div>
            <div class="btn_list">
              <span
                :class="displayMode == 'mini' ? 'repay--mini' : 'repay--normal'"
                v-if="curRecordPos.status == 2 || curRecordPos.status == 3"
                @click="changeRecord(curRecordPos.curIndex - 1)"
              >
                {{ $t('player.player_1028') }}
              </span>
              <span
                :class="displayMode == 'mini' ? 'repay--mini' : 'repay--normal'"
                @click="replayPlay"
              >
                {{ $t('player.player_1016') }}
              </span>
              <span
                :class="displayMode == 'mini' ? 'repay--mini' : 'repay--normal'"
                v-if="curRecordPos.status == 1 || curRecordPos.status == 3"
                @click="changeRecord(curRecordPos.curIndex + 1)"
              >
                {{ $t('player.player_1029') }}
              </span>
            </div>
          </div>
        </div>
        <div
          class="vmp-player-living-audio"
          v-if="isAudio || audioStatus || (webinarMode == 5 && videoWidth === 0)"
        >
          <div>{{ $t('player.player_1014') }}</div>
        </div>
        <div
          class="vmp-player-living-exchange"
          @click="exchangeVideoDocs"
          v-if="isVisibleMiniElement && hoveVideo && !isVodEnd && !isEmbedVideo"
        >
          <p>
            <vh-tooltip :content="$t('player.player_1008')" placement="top">
              <i class="vh-iconfont vh-line-copy-document"></i>
            </vh-tooltip>
          </p>
        </div>
      </template>
      <!-- 控制条 进度条、弹幕、全屏、时间等 -->
      <div
        v-show="isPlaying"
        :class="[
          { 'active-control': hoveVideo, 'previre-control': isTryPreview },
          displayMode == 'mini' ? 'vmp-player-controllerMini' : 'vmp-player-controller'
        ]"
        @mouseenter="controllerMouseEnter"
        @mouseleave="controllerMouseLeave"
      >
        <!-- 进度条 -->
        <div
          class="controller_slider"
          v-if="!isLiving && playerOtherOptions.progress_bar && !isWarnPreview"
        >
          <vh-slider
            ref="controllerRef"
            class="slider_controller"
            v-model="sliderVal"
            :show-tooltip="false"
            :step="1 / Math.floor(totalTime)"
            @change="changeVideo"
            @mousedown.native="handleSliderMouseDown"
          ></vh-slider>
        </div>
        <div
          v-if="totalTime && eventPointList.length && !isWarnPreview"
          ref="vhTailoringWrap"
          class="vmp-player-controller-points"
        >
          <controlEventPoint
            v-for="(item, index) in eventPointList"
            :key="'controlEventPoint' + index"
            :event-time="item.timePoint || item.time"
            :event-label="item.msg"
            :video-time="totalTime"
            :isMini="displayMode == 'mini'"
            :subject="item.subject"
            @showLabel="showLabelFun"
          ></controlEventPoint>
        </div>
        <div class="controller-tools" v-show="!isEmbedPlayerIconHidden">
          <div class="controller-tools-left">
            <div class="controller-tools-left-start" @click="startPlay">
              <!-- 播放/暂停按钮图标 -->
              <i
                v-if="!isHidePauseButtonInLive"
                :class="`vh-iconfont ${isPlaying ? 'vh-a-line-videopause' : 'vh-line-video-play'}`"
              ></i>
            </div>
            <div class="controller-tools-left-time" v-if="!isLiving && !isWarnPreview">
              <template v-if="totalTime > 0">
                <span class="controller-tools-left-time-current">
                  {{ currentTime | secondToDate }}
                </span>
                <span>/</span>
                <span class="controller-tools-left-time-total">{{ totalTime | secondToDate }}</span>
              </template>
              <template v-else>
                <span>--:--/--:--</span>
              </template>
            </div>
          </div>
          <div class="controller-tools-right">
            <div
              class="controller-tools-right-lang"
              v-if="isEmbedVideo && languageList.length > 1 && !isSubscribe"
            >
              <span>{{ lang.label }}</span>
              <ul class="controller-tools-right-list controller-lang">
                <div class="content_base">
                  <li
                    v-for="(item, index) in languageList"
                    :class="{ 'vmp-player-li-active': item.key == lang.key }"
                    @click="changeLanguage(item.key)"
                    :key="index"
                  >
                    {{ item.label }}
                  </li>
                </div>
              </ul>
            </div>

            <!-- 分辨率切换按钮 -->
            <div class="controller-tools-right-quality" v-if="!isWarnPreview && !isTryPreview">
              <span>{{ formatQualityText(currentQualitys.def) }}</span>
              <ul class="controller-tools-right-list">
                <div class="content_base">
                  <li
                    v-for="(item, index) in qualitysList"
                    :class="{ 'vmp-player-li-active': currentQualitys.def == item.def }"
                    @click="changeQualitys(item)"
                    :key="index"
                  >
                    {{ formatQualityText(item.def) }}
                  </li>
                </div>
              </ul>
            </div>
            <div
              class="controller-tools-right-speed"
              v-if="!isLiving && !isWarnPreview && playerOtherOptions.speed"
            >
              <span>
                {{currentSpeed == 1 ? $t('player.player_1007') : currentSpeed.toString().length &lt; 3 ? `${currentSpeed.toFixed(1)}X` : `${currentSpeed}X`}}
              </span>
              <ul class="controller-tools-right-list">
                <div class="content_base">
                  <li
                    v-for="(val, index) in UsableSpeed"
                    :class="{ 'vmp-player-li-active': currentSpeed == val }"
                    @click="changeSpeed(val)"
                    :key="index"
                  >
                    {{val.toString().length &lt; 3 ? `${val.toFixed(1)}X` : `${val}X`}}
                  </li>
                </div>
              </ul>
            </div>

            <!-- 声音开关按钮 -->
            <div class="controller-tools-right-volume">
              <i
                :class="`vh-iconfont ${
                  playerState?.isMuted || voice == 0 ? 'vh-line-mute' : 'vh-line-voice'
                }`"
                @click="handleSwitchMuted"
              ></i>
              <div class="controller-tools-right-volume-slider">
                <div class="volume-slider_base">
                  <vh-slider
                    v-model="voice"
                    vertical
                    height="100px"
                    :show-tooltip="true"
                  ></vh-slider>
                </div>
              </div>
            </div>

            <!-- 弹幕开关按钮 -->
            <div
              class="controller-tools-right-danmuis"
              v-if="!isWarnPreview && playerOtherOptions.barrage_button"
            >
              <i
                :class="`vh-iconfont ${danmuIsOpen ? 'vh-line-barrage-on' : 'vh-line-barrage-off'}`"
                @click="openBarrage"
              ></i>
            </div>
            <!-- 弹幕设置按钮 -->
            <div
              class="controller-tools-right-danmuis"
              style="position: relative"
              v-if="
                !isWarnPreview &&
                !isFullscreen &&
                playerOtherOptions.barrage_button &&
                playerOtherOptions.barrage_style
              "
            >
              <vh-popover
                popper-class="danmaku-setting-popover"
                :popper-options="popperOptions"
                :offset="40"
                placement="top"
                trigger="hover"
              >
                <!-- 弹幕设置面板挂载点 -->
                <div id="danmakuSettingContainer"></div>
                <i class="vh-iconfont vh-a-line-barrage-setup1" slot="reference"></i>
              </vh-popover>
            </div>
            <div @click="rotateVideo">
              <i
                :class="[
                  'vh-iconfont',
                  rotateAngle === 90 ? 'vh-line-landscape' : 'vh-line-vertical-screen'
                ]"
              ></i>
            </div>
            <div
              class="controller-tools-right-pip"
              v-if="canPip && playerOtherOptions.picture_in_picture"
            >
              <i
                :class="`vh-iconfont ${
                  pipIsOpen ? 'vh-line-tuichuhuazhonghua' : 'vh-line-huazhonghua'
                }`"
                @click="openPIP"
              ></i>
            </div>
            <div
              class="controller-tools-right-fullscroll"
              v-if="
                !isWarnPreview && isFullScreenSupported && playerOtherOptions.show_full_screen_entry
              "
            >
              <i
                :class="`vh-iconfont ${
                  isFullscreen ? 'vh-a-line-exitfullscreen' : 'vh-a-line-fullscreen'
                }`"
                @click="enterFullscreen"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vmp-player-tips">
      <div class="vmp-player-tips-box" v-if="isSetQuality || isSetSpeed">
        <!-- 切换清晰度 -->
        <div v-if="isSetQuality">
          {{ $t('player.player_1009') }}
          <span>{{ formatQualityText(currentQualitys.def) }}</span>
        </div>
        <!-- 切换倍速 -->
        <div v-if="isSetSpeed">
          <i18n path="player.player_1015" style="color: #fff">
            <span place="n">
              {{ currentSpeed == 1 ? $t('player.player_1025') : currentSpeed }}
            </span>
          </i18n>
        </div>
      </div>
      <!-- 试看和断点续播提示 -->
      <div class="vmp-player-tips-prew" v-if="displayMode != 'mini' && isPlaying">
        <!-- 试看 -->
        <div v-if="vodType === 'shikan' && isTryPreview">
          <i18n path="appointment.appointment_1012">
            <span class="red" place="n">{{ recordTime }}</span>
          </i18n>
          <span v-if="authText == 6">
            <b @click="authTryWatch(3)">{{ $t('appointment.appointment_1010') }}</b>
            <i style="color: #fff">{{ $t('interact.interact_1020') }}</i>
            <b @click="authTryWatch(4)">{{ $t('appointment.appointment_1011') }}</b>
          </span>
          <span v-else class="red" @click="authTryWatch()">{{ authText }}</span>
          <i class="vh-iconfont vh-line-close" @click="vodType = ''"></i>
        </div>
        <!-- 断点续播 -->
        <div v-if="isPickupVideo && currentTime > 0">
          <i18n path="player.player_1012">
            <span place="n" class="red">{{ currentTime | secondToDate }}</span>
          </i18n>
          <i class="vh-iconfont vh-line-close" @click="isPickupVideo = false"></i>
        </div>
      </div>
    </div>
    <!--视频已过观看有效期-->
    <DialogVideoExpiredPc :visible.sync="dialogVideoExpiredVisible"></DialogVideoExpiredPc>
    <MutedTip :visible.sync="showMutedTip"></MutedTip>
    <div class="webinar-disable" v-if="webinarDisable">
      {{ webinarDisableTip || $t('player.player_1033') }}
    </div>
    <p class="delay_tips" v-if="isDelaying && isLiving">{{ $t('player.player_1034') }}</p>
  </div>
</template>
<script>
  import {
    useRoomBaseServer,
    usePlayerServer,
    useSubscribeServer,
    useAiServer
  } from 'middle-domain';
  import { computeRecordTime, windowVersion } from './js/utils';
  import playerMixins from './js/mixins';
  import controlEventPoint from '../src/components/control-event-point.vue';
  import {
    boxEventOpitons,
    isIE,
    addParamsToUrl,
    isWechat,
    isWechatCom,
    safeJsonParse
  } from '@/app-shared/utils/tool.js';
  import swfList from './js/swf-list.js';
  import { inIframe, vhPlayerSdkEventMessage } from '@/app-shared/utils/common';
  import VmpOrderRank from '@/packages/order-rank';
  import playbackExpirationDateMixin from '@/app-shared/mixins/playbackExpirationDateMixin';
  import DialogVideoExpiredPc from '@/app-shared/components/dialog-video-expired/pc/index.vue';
  import MutedTip from './components/MutedTip.vue';
  import { getCurrentThemeColor } from '@/app-shared/skins/watch';
  import OnlineHot from './components/online-hot.vue';

  export default {
    name: 'VmpPcPlayer',
    mixins: [playerMixins, playbackExpirationDateMixin],
    components: {
      controlEventPoint,
      VmpOrderRank,
      DialogVideoExpiredPc,
      MutedTip,
      OnlineHot
    },
    data() {
      const initIndex = this.subscribeServer.state.initIndex;
      return {
        showMutedTip: false, // 展示静音播放提示
        displayMode: 'normal', // normal: 正常; mini: 小屏; fullscreen:全屏
        isShowPoster: true, //是否展示活动图片背景
        vodType: '', //回放的类型 暖场视频还是还是试看
        liveOption: {}, //直播时播放器liveOption参数
        vodOption: {}, //回放时回放id
        voice: 60, //声音
        sliderVal: 0, //进度条显示
        totalTime: 0, // 视频总时长
        currentSpeed: 1, // 当前倍速
        currentQualitys: {
          def: 'same'
        }, // 当前清晰度
        currentTime: 0, // 视频当前播放时长
        definitionConfig: '360p', //默认清晰度
        audioStatus: false, // 选中清晰度是否是音频模式
        qualitysList: [], //清晰度列表
        UsableSpeed: [], // 视频倍速列表
        danmuIsOpen: false, // 弹幕是否开启
        isFullscreen: false, // 是否是全屏
        isSetSpeed: false, // 是否切换倍速
        isSetQuality: false, // 是否切换清晰度
        recordTime: 0, // 试看的时间
        isTryPreview: false, // 是否是试看
        authText: '', // 试看的权限判断
        isWarnPreview: false, // 是否是暖场视频
        isPickupVideo: false, // 是否是断点续播
        recordHistoryTime: '', // 记录播放的时间
        endTime: '', // 播放到结束时刷新页面
        eventPointList: [], //
        hoveVideo: true, //显示控制条及在线人数和热度
        isLivingEnd: false, // 直播结束
        isVodEnd: false, // 回放结束
        isAutoPlay: false,
        lang: {},
        languageList: [],
        marquee: {}, // 跑马灯
        water: {}, //水印
        agreement: false,
        playerState: {
          isMuted: true
        },
        playerOtherOptions: {
          barrage_button: 0,
          picture_in_picture: 1,
          progress_bar: 0,
          speed: 0,
          autoplay: false,
          pause_button: 1 // 直播状态显示暂停按钮
        }, //播放器配置
        initIndex,
        setIntervalNum: 0,
        pipIsOpen: false,
        dialogVideoExpiredVisible: false,
        rotateAngle: 0,

        // 禁用自动位置调整的 popperOptions 配置
        popperOptions: {
          zIndex: 5000,
          // 强制在上面显示，不改变位置，默认是flip，在空间不足的时候会自动改变placement的位置
          flipBehavior: ['top']
        }
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.subscribeServer = useSubscribeServer();
      this.aiServer = useAiServer();
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.max_min_screen_exchange, this.handleScreenExchange);

      if (document.pictureInPictureElement) {
        document.exitPictureInPicture();
      }
      const players = this.playerServer?.playerInstance?.vhallplayer.getVideo();
      if (players) {
        players.removeEventListener('enterpictureinpicture', this.openPipStatus);
        players.removeEventListener('leavepictureinpicture', this.closePipStatus);
      }

      clearInterval(this.setIntervalNum);
      this.playerServer.isPlaying = false;
      this.playerServer.destroy();

      this.clearVhDepClientDateTimeInternalTask();
    },
    computed: {
      //延迟直播无流阶段
      isDelaying() {
        return this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.is_delaying;
      },
      //直播间封禁，1:封禁 0 解封
      webinarDisable() {
        return (
          this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.is_disable &&
          this.webinarType == 1
        );
      },
      //直播建封禁提示
      webinarDisableTip() {
        return this.$domainStore.state.roomBaseServer.watchInitData?.webinar?.disable_host_tip;
      },
      // 直播模式：1-音频直播、2-视频直播、3-互动直播 6-分组直播 5 定时直播
      webinarMode() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode;
      },
      languagesInfo() {
        return this.$domainStore.state.roomBaseServer.languages.curLang;
      },
      // 是否观看端
      isWatch() {
        return !['send', 'record'].includes(this.roomBaseServer.state.clientType);
      },
      //判断是否是音频直播模式
      isAudio() {
        return this.roomBaseServer.state.watchInitData.webinar.mode == 1;
      },
      // 是否正在直播
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      // 初始化了第几个
      initPlayerIndex() {
        return this.$domainStore.state.subscribeServer.initIndex;
      },
      // 播放第几个
      playIndex() {
        return this.$domainStore.state.subscribeServer.playIndex;
      },
      warmUpVideoList() {
        return this.$domainStore.state.roomBaseServer.warmUpVideo.warmup_paas_record_id;
      },
      subscribeWarmList() {
        return this.$domainStore.state.subscribeServer.subscribeWarmList;
      },
      // 暖场视频播放模式
      warmPlayMode() {
        return this.$domainStore.state.roomBaseServer.warmUpVideo.warmup_player_type;
      },
      // 背景图片
      webinarsBgImg() {
        const cover = '//cnstatic01.e.vhall.com/static/images/mobile/video_default_nologo.png';
        const { warmup, webinar } = this.roomBaseServer.state.watchInitData;
        let webinarUrl = cover;
        if (webinar.img_url) {
          webinarUrl = webinar.img_url;
        }
        if (this.warmUpVideoList.length) {
          if (warmup.warmup_img_url) {
            return warmup.warmup_img_url;
          } else {
            return webinarUrl;
          }
        } else {
          return webinarUrl;
        }
      },
      isShowContainer() {
        if (this.isSubscribe && this.warmUpVideoList.length > 0) {
          // 预约页，有暖场视频，一定初始化播放器； 解决无延迟直播开播之后，没有通过观看限制，暖场视频看不了的问题
          return false;
        } else {
          return (
            !this.$domainStore.state.interactiveServer.initInteractiveFailed &&
            (this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode == 6 ||
              this.$domainStore.state.micServer.isSpeakOn ||
              this.isLivingEnd) &&
            this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1
          );
        }
      },
      isVisibleMiniElement() {
        // 添加插播桌面共享后，再添加插播桌面共享场景的处理
        return (
          this.$domainStore.state.docServer.switchStatus &&
          this.$domainStore.state.roomBaseServer.interactToolStatus.speakerAndShowLayout != 1
        );
      },
      isSubscribe() {
        return (
          this.$domainStore.state.roomBaseServer.watchInitData.status == 'subscribe' &&
          !this.$domainStore.state.roomBaseServer.watchInitData.record.preview_paas_record_id
        );
      },
      // 无延迟直播
      isNoDelay() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.no_delay_webinar;
      },
      // 是否是嵌入
      isEmbed() {
        return this.$domainStore.state.roomBaseServer.embedObj.embed;
      },
      isEmbedVideo() {
        // 是不是单视频嵌入
        return this.$domainStore.state.roomBaseServer.embedObj.embedVideo;
      },
      // 播放状态
      isPlaying() {
        return this.$domainStore.state.playerServer.isPlaying;
      },
      // 是否是cms嵌入
      isCms() {
        return this.$domainStore.state.roomBaseServer.isCms == 1;
      },
      mainBackground() {
        let skinInfo = this.$domainStore.state.roomBaseServer.skinInfo;
        let skinJsonPc = {};
        if (skinInfo?.skin_json_pc && skinInfo.skin_json_pc != 'null') {
          skinJsonPc = skinInfo.skin_json_pc;
        }
        return skinJsonPc?.videoBackGroundColor || '#000';
      },
      //是否支持画中画
      canPip() {
        return document.pictureInPictureEnabled;
      },
      needLogin() {
        return (
          // this.isCms &&
          !this.isTryPreview &&
          !this.isWarnPreview &&
          this.notLogged &&
          this.roomBaseServer.state.configList['show_set_login'] + '' === '1' &&
          this.roomBaseServer.state.configList['hard_login'] + '' === '1'
        );
      },
      notLogged() {
        let notLogged = false;
        if (this.isEmbed) {
          // 嵌入页
          const { third_user_id = '', email = '' } = this.$route.query;
          if (
            !(
              third_user_id ||
              email ||
              (this.roomBaseServer.state.watchInitData.join_info.reg_form &&
                this.roomBaseServer.state.watchInitData.join_info.verified)
            )
          ) {
            notLogged = true;
          }
        } else {
          // 标品
          if (!sessionStorage.getItem('token')) {
            notLogged = true;
          }
        }
        return notLogged;
      },
      embedMode() {
        // 全局嵌入页判断
        return this.$route.query.embedMode || this.$route.query.embed_mode;
      },
      // 是否展示分享
      isShowShare() {
        return this.$domainStore.state.roomBaseServer.configList['ui.watch_hide_share'];
      },
      // 活动状态（2-预约 1-直播 3-结束 4-点播 5-回放）
      webinarType() {
        return Number(this.roomBaseServer.state.watchInitData.webinar.type);
      },
      aiSubtitleSwitch() {
        return this.$domainStore.state.aiServer.subtitleSwitch;
      },
      aiSubtitleStyle() {
        return this.$domainStore.state.aiServer.subtitleStyle;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList || {};
      },
      // 播放器 右侧 是否隐藏菜单 仅pc生效
      isHideRightMenu() {
        return this.configList['ui.hidden_custom_menu'] + '' === '1';
      },
      // 单视频嵌入播放器功能隐藏
      isEmbedPlayerIconHidden() {
        return this.configList['embed.player_icon_hidden'] + '' === '1' && this.isEmbedVideo;
      },
      showOrderRank() {
        // 直播 且 非视频嵌入 且 直播中 且 开通订单排行榜开关
        // 注意：由于 开通订单排行榜开关 涉及到实时消息通知，故统一放到 消息排行榜组件内部控制

        return (
          [1].includes(this.webinarType) && !this.isEmbedVideo && this.isPlaying /*&&
        this.openOrderRankSwitch*/
        );
      },
      curRecordId() {
        return this.$domainStore.state.roomBaseServer.watchInitData?.record?.record_id;
      },
      playbackList() {
        return this.$domainStore.state.playbackServer.playbackList || [];
      },
      //0不展示上一个下一个，1展示下一个，2展示上一个，3展示上一个和下一个
      curRecordPos() {
        let status = 0;
        let curIndex = -1;
        if (this.webinarType == 5 && this.playbackList.length) {
          curIndex = this.playbackList.findIndex(el => {
            return el.id == this.curRecordId;
          });
          if (0 < curIndex && curIndex < this.playbackList.length - 1) {
            status = 3;
          } else if (curIndex < this.playbackList.length - 1) {
            status = 1;
          } else if (curIndex > 0) {
            status = 2;
          }
        }
        return {
          status,
          curIndex
        };
      },
      videoWidth() {
        return this.$domainStore.state.playerServer.videoWidth;
      },
      // 是否在直播状态中不显示暂停按钮
      isHidePauseButtonInLive() {
        return this.isLiving && this.playerOtherOptions?.pause_button === 0;
      }
      // openOrderRankSwitch() {
      //   return this.configList['ui.order_rank_switch'] + '' === '1'; // admin 订单排行榜开关 1: 开启 0:关闭
      // }
    },
    watch: {
      webinarDisable(val, oldVal) {
        if (val == 1 && val != oldVal) {
          this.playerServer.exitFullScreen();
        }
      },
      'playerState.isMuted': {
        handler(newVal) {
          if (newVal) {
            // 静音
            this.defaultVoice = this.voice; // 记录静音之前的声音
            this.voice = 0;
          } else if (!newVal) {
            // 非静音
            this.voice = this.defaultVoice || 60;
          }
          if (this.isWarnPreview) {
            this.subscribeServer.state.warmVideo = this.voice;
          }
        },
        immediate: false
      },
      'playerState.isPlaying': {
        handler(newVal) {
          if (newVal) {
            this.isShowPoster = false;
          }
        },
        immediate: false
      },
      voice(newVal) {
        this.playerServer.setVolume(newVal, () => {
          console.log('设置音量失败');
        });
      },
      hoveVideo(newValue) {
        if (newValue) {
          clearTimeout(this.hoverVideoTimer);
          this.hoverVideoTimer = setTimeout(() => {
            this.hoveVideo = false;
          }, 3000);
        }
      },
      ['roomBaseServer.state.miniElement'](newval) {
        if (!this.isEmbedVideo) {
          this.displayMode = newval === 'player' ? 'mini' : 'normal';
        }
      },
      playIndex() {
        // 暖场视频才监听播放的顺序
        if (!this.isWarnPreview) return;
        // 如果上一个视频音量进行修改，下一个视频，音量不变
        this.voice = this.subscribeServer.state.warmVideo;
        this.playerServer.setVolume(this.voice, () => {
          console.log('设置音量失败');
        });
        // 多个视频持续播放 暖场视频播放模式
        if (this.warmUpVideoList.length > 1) {
          // 如果是循环播放，播完最后一个，自动播第一个
          if (
            this.warmPlayMode == 2 &&
            this.warmUpVideoList[this.initIndex] === this.warmUpVideoList[this.playIndex]
          ) {
            this.playerServer.play();
            this.$nextTick(() => {
              if (document.pictureInPictureElement && document.pictureInPictureEnabled) {
                const players = this.playerServer?.playerInstance?.vhallplayer.getVideo();
                players.requestPictureInPicture();
              }
            });
          }
          // 如果是单次播放，播完第一个，自动播放第二个
          if (
            this.warmPlayMode == 1 &&
            this.warmUpVideoList[this.initIndex] === this.warmUpVideoList[this.playIndex] &&
            this.playIndex > 0
          ) {
            this.playerServer.play();
            this.$nextTick(() => {
              if (document.pictureInPictureElement && document.pictureInPictureEnabled) {
                const players = this.playerServer?.playerInstance?.vhallplayer.getVideo();
                players.requestPictureInPicture();
              }
            });
          }
        }
      }
    },
    created() {
      // 收到PC看端[固定大小屏切换按钮]点击消息处理
      this.$emitter.on(this.$EMIT_DEFINE.max_min_screen_exchange, this.handleScreenExchange);

      // 如果暖场视频的长度大于1，就用多例。否则就用单例
      this.playerServer = usePlayerServer({
        extra: this.warmUpVideoList.length > 1
      });
      this.playerState = this.playerServer.state;
      if (this.isShowContainer) return;
      this.getWebinerStatus();
      const { agreement } = this.roomBaseServer.state.watchInitData;
      this.agreement = agreement.is_open && !agreement.is_agree ? true : false;
      if (this.isEmbedVideo) {
        this.languageList = this.roomBaseServer.state.languages.langList;
        this.lang = this.roomBaseServer.state.languages.lang;
      }

      document.addEventListener('keydown', event => {
        console.log('event --->>>', event);
        if (event.code === 'ArrowUp') {
          // 判断按下的是否为向上按钮
          console.log('触发了向上按钮');
        } else if (event.code === 'ArrowDown') {
          // 判断按下的是否为向下按钮
          console.log('触发了向下按钮');
        } else if (event.code === 'ArrowLeft') {
          // 判断按下的是否为向下按钮
          console.log('触发了向左按钮');
          if (this.isPlaying) {
            this.showLabelFun(this.currentTime - 5 < 0 ? 0 : this.currentTime - 5);
          }
        } else if (event.code === 'ArrowRight') {
          // 判断按下的是否为向下按钮
          console.log('触发了向右按钮');
          if (this.isPlaying) {
            this.showLabelFun(
              this.currentTime + 5 < this.totalTime ? this.currentTime + 5 : this.totalTime
            );
          }
        } else if (event.code === 'Space') {
          // 判断按下的键是否为空格键
          console.log('空格键被按下');
          // 这里写入处理空格键按下后的操作代码
          if (this.isVodEnd) {
            this.replayPlay();
          }
        }
      });
      this.handleVhDepClientDateTime();
    },
    mounted() {
      if (this.isEmbedVideo && !this.isWarnPreview) {
        const centerDom = document.querySelector('.vmp-basic-center');
        centerDom.style.width = '100%';
      }
    },

    methods: {
      handleScreenExchange() {
        console.log('max_min_screen_exchange trigger[pc-player]');
        if (
          !this.isShowContainer &&
          this.isVisibleMiniElement &&
          !this.isVodEnd &&
          !this.isEmbedVideo
        ) {
          console.log('max_min_screen_exchange on: pc-player');
          this.exchangeVideoDocs();
        }
      },
      // 旋转视频
      rotateVideo() {
        this.rotateAngle = this.rotateAngle === 90 ? 0 : 90;

        const videoElement = document.getElementById('vmp-player-vhall-video');
        if (videoElement) {
          const container = videoElement.parentElement;
          if (container) {
            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;

            const videoWidth = videoElement.clientWidth || 1920;
            const videoHeight = videoElement.clientHeight || 1080;

            let scale = 1;
            if (this.rotateAngle === 90) {
              // 旋转90度时，视频宽高交换
              const scaleX = containerWidth / videoHeight;
              const scaleY = containerHeight / videoWidth;
              scale = Math.min(scaleX, scaleY);
            } else {
              // 0度时，正常宽高
              const scaleX = containerWidth / videoWidth;
              const scaleY = containerHeight / videoHeight;
              scale = Math.min(scaleX, scaleY);
            }

            if (!isNaN(scale) && isFinite(scale) && scale > 0) {
              videoElement.style.transform = `rotate(${this.rotateAngle}deg) scale(${scale})`;
            } else {
              videoElement.style.transform = `rotate(${this.rotateAngle}deg)`;
            }
            videoElement.style.transformOrigin = 'center center';
          } else {
            videoElement.style.transform = `rotate(${this.rotateAngle}deg)`;
          }
        }
      },

      // 初始化播放器配置项
      async initConfig() {
        let params = {
          language: this.languagesInfo?.language_type == 2 ? 'en' : 'zh',
          videoNode:
            this.warmUpVideoList.length < 2
              ? 'vmp-player'
              : `vmp-player-vod_${this.warmUpVideoList[this.initIndex]}`
        };
        if (this.playerServer.state.type === 'live') {
          params = Object.assign(params, {
            liveOption: this.liveOption
          });
          // 处理直播自动播放, 如果需要登录自动播放开了也无效
          if (this.isAutoPlay || this.playerOtherOptions.autoplay == 1) {
            params.autoplay = this.needLogin ? false : true;
            params.autoplayMuteAttempt = this.needLogin ? false : true; // 自动播放支持静音播放尝试
          }
        } else if (this.playerServer.state.type === 'vod') {
          params = Object.assign(params, {
            vodOption: this.vodOption,
            pursueOption: { enable: true }
          });
          // 处理点播自动播放, 如果需要登录自动播放开了也无效
          if (this.isAutoPlay || this.playerOtherOptions.autoplay == 1) {
            params.autoplay = this.needLogin ? false : true;
            params.autoplayMuteAttempt = this.needLogin ? false : true; // 自动播放支持静音播放尝试
          }
          // 获取点播字幕相关配置信息
          await this.getVodSubtitlesConfig();
          const enable = this.aiSubtitleSwitch === 0 ? false : true;
          params.vodSubtitleOption = { enable: enable };
          if (enable && this.aiSubtitleStyle) {
            const transCssObj = {
              // 字体大小，单位em
              fontSize: `${this.aiSubtitleStyle.font_size}em`,
              color: this.aiSubtitleStyle.font_color /* 设置字体颜色 */,
              fontWeight: this.aiSubtitleStyle.is_bold ? 'bold' : 'normal',
              textDecoration: this.aiSubtitleStyle.is_underline ? 'underline' : 'none',
              fontStyle: this.aiSubtitleStyle.is_incline ? 'italic' : 'normal',
              opacity: this.aiSubtitleStyle.opacity / 100
            };
            /* 字幕文本的“描边”效果 */
            if (!this.aiSubtitleStyle.stroke_color) {
              transCssObj.textShadow = 'none';
            } else {
              const w = `${this.aiSubtitleStyle.stroke_width}px`;
              const c = `${this.aiSubtitleStyle.stroke_color}`;
              transCssObj.textShadow = `-${w} -${w} 0 ${c}, ${w} -${w} 0 ${c}, -${w} ${w} 0 ${c}, ${w} ${w} 0 ${c}`;
            }
            params.vodSubtitleOption.style = transCssObj;
          }
        } else {
          throw new Error('Parameter error--2');
        } // 获取跑马灯、水印等播放器配置 不等于暖场视频
        if (!this.isWarnPreview) {
          // 跑马灯
          if (this.marquee && this.marquee.scrolling_open == 1) {
            let marqueeText = '';
            if (this.marquee.text_type == 1) {
              marqueeText = this.marquee.text;
            } else {
              let text = this.getWatcherIdAndNickname();
              marqueeText = `${text}`;
            }
            params.marqueeOption = {
              enable: Boolean(marqueeText),
              text: marqueeText, // 跑马灯的文字
              alpha: this.marquee.alpha, // 透明度,100完全显示,0 隐藏
              size: this.marquee.size, // 文字大小
              color: this.marquee.color, // 文字颜色
              interval: this.marquee.scroll_type == 1 ? this.marquee.interval : 1, // 下次跑马灯开始与本次结束的时间间隔 ， 秒为单位
              speed: this.marquee.speed || 6000, // 跑马灯移动速度:3000快,6000中,10000慢
              displayType: this.marquee.scroll_type == 1 ? 0 : 1,
              position: this.marquee.position // 跑马灯位置 , 1 随机 2上,3中 4下
            };
          }
          // 播放器水印
          if (this.water) {
            if (this.water.watermark_open == 1) {
              // 图片类型水印
              const align = this.getWaterImagePostion(this.water.img_position);
              const size = this.getWaterImageSize(this.water);
              params.watermarkOption = {
                enable: true,
                mode: 'image',
                url: this.water.img_url, // 水印图片的路径
                align, // 图片的对其方式， tl | tr | bl | br 分别对应：左上，右上，左下，右下
                position: ['20px', '20px'], // 对应的横纵位置，支持px,vh,vw,%
                size, // 水印大小，支持px,vh,vw,%
                alpha: this.water.img_alpha
              };
            } else if (this.water.text_watermark_open == 1) {
              // 文本类型水印
              const textWatermark = safeJsonParse(this.water.text_watermark);
              if (textWatermark) {
                params.watermarkOption = {
                  enable: true,
                  mode: 'text',
                  textConfig: {
                    content:
                      textWatermark.text_type == 2
                        ? this.getWatcherIdAndNickname()
                        : textWatermark.text_value, // 文本内容 1-固定文本 2-观看者id和昵称
                    size: textWatermark.size + 'px', // 文字大小
                    color: textWatermark.color, // 文字颜色
                    opacity: textWatermark.alpha, // 不透明度（0-100）
                    multiline: textWatermark.line_mode == 2 ? true : false, // 1-单行，2-多行
                    degrees: textWatermark.orientation == 1 ? -45 : 0 // 1-倾斜，2-水平
                  }
                };
              }
            }
          }
        }
        return params;
      },
      // 获取观看者id和昵称
      getWatcherIdAndNickname() {
        const { join_info } = this.roomBaseServer.state.watchInitData;
        let text = '';
        if (join_info.join_id) {
          text = `${join_info.join_id}-${join_info.nickname}`;
        } else {
          let userInfo = localStorage.getItem('userInfo');
          if (userInfo) {
            try {
              userInfo = JSON.parse(localStorage.getItem('userInfo'));
              text = `${userInfo?.user_id}-${userInfo?.nick_name}`;
            } catch (err) {
              console.log(err);
            }
          } else {
            text = '';
          }
        }
        return text;
      },
      // 获取图片类型水印的位置
      getWaterImagePostion(position) {
        const alianMap = new Map([
          [1, 'tl'],
          [2, 'tr'],
          [3, 'br'],
          [4, 'bl']
        ]);
        return alianMap.get(parseInt(position));
      },
      // 获取图片类型水印的大小
      getWaterImageSize(water) {
        const { img_size } = water;
        let size = ['10%', '10%'];
        switch (img_size) {
          case 1:
            size = ['12%', '12%'];
            break;
          case 2:
            size = ['10%', '10%'];
            break;
          case 3:
            size = ['8%', '8%'];
            break;
          default:
            size = ['10%', '10%'];
        }
        return size;
      },
      // 初始化播放器
      async initPlayer(opt) {
        this.loading = true;
        console.log(`%c[pc]播放器sdk 初始化开始`, 'color:blue');
        let defineQuality = this.setDefaultQuality();
        if (
          this.roomBaseServer.state.configList['live_hidden_same'] == 1 &&
          defineQuality === 'same'
        ) {
          // 如果配置了隐藏原画，但是defineQuality==same，则强制更改成360p
          defineQuality = '360p';
        }
        if (this.playerServer.state.type === 'live') {
          this.liveOption.defaultDefinition = defineQuality || '';
        } else if (this.playerServer.state.type === 'vod') {
          this.vodOption.defaultDefinition = defineQuality || '';
        }

        console.log(`%c[pc]播放器sdk 协议: ${this.liveOption.type}`, 'color:blue');
        const params = await this.initConfig();
        const themeColor = await getCurrentThemeColor();

        // 去除先前旧的弹幕缓存
        const barrageSettingFromStorage = safeJsonParse(
          localStorage.getItem('vhall_player_barrageSetting')
        );
        const speed = barrageSettingFromStorage?.speed;
        if (speed && ![5000, 10000, 20000].includes(speed)) {
          localStorage.removeItem('vhall_player_barrageSetting');
        }
        params.barrageSetting = {
          popupBlock: true,
          popupContainer: '#danmakuSettingContainer',
          popupStyle: {
            themeColor: themeColor ?? '#fb2626'
          }
        };
        console.log(`%c[pc]播放器sdk 参数:\r\n${JSON.stringify(params)}`, 'color:blue');
        return this.playerServer.init(params).then(() => {
          console.log(params, '播放器初始化成功123');
          this.initSuccess = true;
          this.playerServer.openControls(false);
          this.playerServer.openUI(false);

          this.loading = false;
          window[`player${this.initIndex}`] = this.playerServer;
          this.getQualitys(); // 获取清晰度列表和当前清晰度
          this.listenEvents();
          this.getListenPlayer();

          this.danmuIsOpen = sessionStorage.getItem('vhall_player_barrageOpen') ? true : false;
          this.danmuIsOpen ? this.playerServer.openBarrage() : this.playerServer.closeBarrage();

          if (this.playerServer.state.type === 'vod') {
            // 精彩时刻打点和回放剪辑台打点合并
            const points = [].concat(this.playerServer.state.momentsList);
            for (const item of this.playerServer.state.markPoints) {
              if (points.findIndex(p => p.time === item.timePoint) === -1) {
                points.push({
                  image_url: item.picurl,
                  subject: item.msg,
                  time: item.timePoint
                });
              }
            }
            this.eventPointList = points;
            this.getRecordTotalTime(); // 获取视频总时长
            this.initSlider(); // 初始化播放进度条
            this.getInitSpeed(); // 获取倍速列表和当前倍速
            if (
              !this.isWarnPreview &&
              (this.isAutoPlay || this.playerOtherOptions.autoplay == 1) &&
              !this.needLogin &&
              opt?.from !== 'MicDown' &&
              !isWechat() &&
              !isWechatCom()
            ) {
              this.showMutedTip = true;
            }
          } else {
            if (
              (this.isAutoPlay || this.playerOtherOptions.autoplay == 1) &&
              !this.needLogin &&
              opt?.from !== 'MicDown' &&
              !isWechat() &&
              !isWechatCom()
            ) {
              this.showMutedTip = true;
            }
          }

          this.$nextTick(() => {
            const players = this.playerServer?.playerInstance?.vhallplayer.getVideo();
            players.poster = this.webinarsBgImg;

            players.addEventListener('enterpictureinpicture', this.openPipStatus);
            players.addEventListener('leavepictureinpicture', this.closePipStatus);

            try {
              if (inIframe) {
                let video_content_type = 0; // 视频内容类别
                if (this.isWarnPreview) {
                  // 暖场视频
                  video_content_type = 1;
                } else if (this.playerServer.state.type === 'live') {
                  // 直播
                  video_content_type = 2;
                } else if (this.playerServer.state.type === 'vod') {
                  // 点播
                  video_content_type = 3;
                }
                this.playerServer?.$on(window.VhallPlayer.PAUSE, () => {
                  vhPlayerSdkEventMessage({
                    event_type: 'PAUSE',
                    video_content_type
                  });
                });
                this.playerServer?.$on(window.VhallPlayer.PLAY, () => {
                  vhPlayerSdkEventMessage({
                    event_type: 'PLAY',
                    video_content_type
                  });
                });
                this.playerServer?.$on(window.VhallPlayer.ENDED, () => {
                  vhPlayerSdkEventMessage({
                    event_type: 'ENDED',
                    video_content_type
                  });
                });
              }
            } catch (e) {
              console.error('playerinit inIframe:', e);
            }
          });
        });
      },
      authTryWatch(type) {
        /**
         * 公共组件
         * 当前未登录
         * B租户 开启强制登录
         * 网络研讨会 开启强制登录
         */
        if (this.needLogin) {
          // 单场大会被第三方嵌入（嵌套wap-meeting、watch-meeting）
          // webcasting嵌入页 且 被iframe嵌套
          window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitClickLogin'));
          return true;
        }

        let params = {
          type: this.authText == 6 ? type : this.roomBaseServer.state.watchInitData.webinar.verify
        };
        if (this.agreement) {
          this.roomBaseServer.$emit('POPUP_AGREEMENT');
        } else {
          this.feeAuth(params);
        }
      },
      feeAuth(params) {
        let data = {
          webinar_id: this.roomBaseServer.state.watchInitData.webinar.id,
          visitor_id: this.roomBaseServer.state.watchInitData.visitor_id,
          ...this.$route.query,
          ...params
        };
        if (this.isEmbed) {
          // 消息通知 - 添加参数字段
          data.clientType = 'embed';
          data.embed_type = this.isEmbedVideo ? 'video' : 'full';
          if (!inIframe) {
            data.is_iframe = 0; // 1:嵌入 0:非嵌入
          }
        }
        this.subscribeServer.watchAuth(data).then(res => {
          if (res.code == 200) {
            if (res.data.status === 'live') {
              window.location.href =
                window.location.origin +
                process.env.VUE_APP_ROUTER_BASE_URL +
                (this.isCms ? '/meeting' : '') +
                `/lives/watch/${this.roomBaseServer.state.watchInitData.webinar.id}${window.location.search}`;
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } else {
            this.handleAuthErrorCode(res.code, res.msg);
          }
        });
      },
      handleAuthErrorCode(code, msg) {
        let placeHolderInfo = {
          placeHolder: '',
          webinarId: '',
          isSubject: false,
          isWhiteCheck: false // 是否开启了白名单验证
        };
        switch (code) {
          case 510008: // 未登录
            window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitClickLogin'));
            break;
          case 512601: // 正在审核
          case 512602: // 审核未通过
          case 512525: // 填写表单emitClickOpenSignUpForm
            // 如果是cms，打开cms报名表单
            if (this.isCms) {
              window.parent.postMessage(
                {
                  type: 'openSignUpForm_webToCms',
                  data: {}
                },
                '*'
              );
            } else {
              window.$middleEventSdk?.event?.send(
                boxEventOpitons(this.cuid, 'emitClickOpenSignUpForm')
              );
            }
            break;
          case 512002:
          case 512522:
            setTimeout(() => {
              window.location.reload();
            }, 1500);
            break;
          case 512531:
            // 邀请码
            placeHolderInfo.placeHolder =
              this.roomBaseServer.state.watchInitData.webinar.verify_tip ||
              this.$t('appointment.appointment_1024');
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitClickAuth', placeHolderInfo)
            );
            break;
          case 512528:
            // 密码
            placeHolderInfo.placeHolder = this.authText || this.$t('appointment.appointment_1022');
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitClickAuth', placeHolderInfo)
            );
            break;
          case 512532:
            //白名单
            placeHolderInfo.placeHolder = this.authText || this.$t('common.common_1006');
            placeHolderInfo.isWhiteCheck = true;
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitClickAuth', placeHolderInfo)
            );
            break;
          case 512523:
            // 付费
            window.$middleEventSdk?.event?.send(
              boxEventOpitons(this.cuid, 'emitClickPay', { flag: true })
            );
            break;
          case 510019: // 未登录
            window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitClickLogin'));
            break;
          default:
            this.$message({
              message: this.$tec(code) || msg,
              showClose: true,
              // duration: 0,
              type: 'warning',
              customClass: 'zdy-info-box'
            });
            break;
        }
      },
      handleAgreeWitthTerms() {
        this.agreement = false;
        this.getShiPreview();
        const verify = this.roomBaseServer.state.watchInitData.webinar.verify;
        const type = verify === 6 ? 4 : verify;
        this.authTryWatch(type);
      },
      closePayFee() {
        window.$middleEventSdk?.event?.send(
          boxEventOpitons(this.cuid, 'emitClickPay', { flag: false })
        );
      },
      startPlay() {
        /**
         * 公共组件
         * 当前未登录
         * B租户 开启强制登录
         * 网络研讨会 开启强制登录
         */
        if (this.needLogin) {
          // 单场大会被第三方嵌入（嵌套wap-meeting、watch-meeting）
          // webcasting嵌入页 且 被iframe嵌套
          window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitClickLogin'));
        } else {
          if (!this.checkPlaybackExpiredDateTime()) {
            this.showPlaybackExpiredMsg();
            return false;
          }
          this.isPlaying ? this.pause() : this.play();
        }
      },
      // 播放
      play() {
        // 为了防止 播放器初始化还没完成，就点击了播放器按钮播放
        try {
          this.playerServer && this.playerServer.play();
        } catch (error) {
          console.log(error);
        }
      },
      // 暂停
      pause() {
        this.playerServer && this.playerServer.pause();
      },
      // 重新播放
      replayPlay() {
        this.isVodEnd = false;
        this.startPlay();
      },
      changeRecord(index) {
        window.location.href = addParamsToUrl(window.location.href, {
          record_id: this.playbackList[index].id
        });
      },
      handleSliderMouseDown() {
        // 鼠标拖动的时候，阻止slider值更新
        if (!this._isSetingCurrentTime) {
          this._isSetingCurrentTime = true;
        }
      },
      changeVideo() {
        const time = (this.sliderVal / 100) * this.totalTime; // 快进
        this.setVideoCurrentTime(time);
        this.play();
      },
      // 切换多语言
      changeLanguage(key) {
        localStorage.setItem('lang', key);
        const params = this.$route.query;
        // 如果地址栏中有语言类型，当切换语言时，对应的地址栏参数要改变
        if (params.lang) {
          params.lang = key;
          let sourceUrl =
            window.location.origin +
            process.env.VUE_APP_ROUTER_BASE_URL +
            (this.isCms ? '/meeting' : '') +
            this.$route.path;
          let queryKeys = '';
          for (const k in params) {
            queryKeys += k + '=' + params[k] + '&';
          }
          queryKeys = queryKeys.substring(0, queryKeys.length - 1);
          sourceUrl = sourceUrl + '?' + queryKeys;
          window.location.href = sourceUrl;
        } else {
          window.location.reload();
        }
      },
      // 判断是直播还是回放 活动状态
      getWebinerStatus(info) {
        if (info && info.autoPlay) {
          this.isAutoPlay = info.autoPlay;
        }
        const { webinar, warmup, record } = this.roomBaseServer.state.watchInitData;
        if (this.roomBaseServer.state.watchInitData.status === 'live') {
          if (webinar.type === 1) {
            // 直播
            this.optionTypeInfo('live', undefined, info);
          } else if (webinar.type === 5 || webinar.type === 4) {
            // 回放
            this.optionTypeInfo(
              'vod',
              this.roomBaseServer.state.watchInitData.paas_record_id,
              info
            );
            this.recordHistoryTime = localStorage.getItem(
              this.roomBaseServer.state.watchInitData.paas_record_id
            )
              ? Number(localStorage.getItem(this.roomBaseServer.state.watchInitData.paas_record_id))
              : 0;
            console.log(this.recordHistoryTime, 'this.recordHistoryTime');
          }
        } else {
          if (webinar.type === 3) return; //结束状态
          // 1-直播中，2-预约，3-结束，4-点播，5-回放
          // 点播回放没有暖场，但是可能有试看
          if (webinar.type === 5 || webinar.type === 4) {
            // 试看
            this.vodType = 'shikan';
            this.isTryPreview = true;
            this.getShiPreview();
            this.optionTypeInfo('vod', record.preview_paas_record_id, info);
          } else {
            if (this.warmUpVideoList.length) {
              this.vodType = 'warm';
              this.isWarnPreview = true;
              this.optionTypeInfo('vod', this.warmUpVideoList[this.initIndex], info);
            }
          }
        }
      },
      optionTypeInfo(type, id, opt) {
        // 暖场视频或者试看
        const winVersion = windowVersion();
        const ua = window.navigator.userAgent;
        const swf = swfList.some(item => {
          return ua.includes(item);
        });
        // 直播
        this.playerServer.setType(type);
        if (type === 'live') {
          this.vodOption = {};
          this.liveOption = {
            type: 'auto',
            roomId: this.roomBaseServer.state.watchInitData.interact.room_id
          };
          if (
            this.roomBaseServer.state.configList['media_server.watch.rtmp_pc_to_hls'] == 1 ||
            isIE()
          ) {
            this.liveOption.type = 'hls';
          } else if (this.isNoDelay) {
            this.liveOption.type = 'rtl'; //快直播
          }
          if (isIE() && winVersion === 'win10') {
            this.liveOption.useSWF = false;
          } else if ((isIE() && winVersion === 'win7') || swf) {
            this.liveOption.useSWF = true;
            this.vodOption.useSWF = true;
          }
        } else {
          this.vodOption.recordId = id;
          this.liveOption = {};
          if (isIE() && winVersion === 'win10') {
            this.liveOption.useSWF = false;
          } else if ((isIE() && winVersion === 'win7') || swf) {
            this.liveOption.useSWF = true;
            this.vodOption.useSWF = true;
          }
        }
        if (this.isWarnPreview) {
          this.initPlayer(opt);
        } else {
          const unionConfig = this.roomBaseServer.state.unionConfig;
          console.log(unionConfig, '????12342355466756---pc');
          this.definitionConfig = unionConfig.definition.data.default_definition;
          if (this.isNoDelay && this.roomBaseServer.state.configList['live_hidden_same'] != 1) {
            // 快直播 且 不隐藏原画, 则改成默认原画
            this.definitionConfig = 'same';
          }
          this.marquee = unionConfig['screen-config'] && unionConfig['screen-config'].data;
          this.water = unionConfig['water-mark'] && unionConfig['water-mark'].data;
          this.playerOtherOptions = unionConfig['basic-config'] && unionConfig['basic-config'].data;
          this.initPlayer(opt);
        }
      },
      exchangeVideoDocs() {
        if (this.displayMode === 'mini') {
          this.roomBaseServer.setChangeElement('doc');
          this.displayMode = 'normal';
        } else {
          this.roomBaseServer.setChangeElement('player');
          this.displayMode = 'mini';
        }
      },
      // 获取回放总时长
      getRecordTotalTime() {
        let getRecordTotalTimer = null;
        // 回放时间异步获取 需要通过定时器获取
        getRecordTotalTimer = setInterval(() => {
          try {
            this.totalTime =
              (this.playerServer &&
                this.playerServer.getDuration(() => {
                  console.log('获取视频总时长失败');
                })) ||
              0;
            this.totalTime > 0 && clearInterval(getRecordTotalTimer);
          } catch (error) {
            console.log(error);
          }

          if (this.isTryPreview && this.totalTime) {
            this.recordTime = computeRecordTime(this.totalTime);
            if (this.recordTime === 0) {
              this.recordTime = 1;
            }
            console.log(this.isTryPreview, '???1323');
          } else {
            if (this.subscribeServer.state.isChangeOrder && this.isWarnPreview) return;
            if (this.isWarnPreview) {
              if (this.warmUpVideoList[this.initIndex] == localStorage.getItem('warm_recordId')) {
                this.getDuanxuPreview(); //断点续播逻辑
              }
            } else {
              this.getDuanxuPreview(); //断点续播逻辑
            }
          }
        }, 50);
      },
      getDuanxuPreview() {
        let endTime;
        const parsedTotalTime = parseInt(this.totalTime);
        if (this.recordHistoryTime != '') {
          endTime = parseFloat(this.recordHistoryTime);
          const parsedEndTime = parseInt(this.recordHistoryTime);
          if (endTime && endTime != 'undefined' && parsedTotalTime != parsedEndTime) {
            const seekTime = endTime < 6 ? 0 : endTime - 5;
            if (seekTime) {
              this.isPickupVideo = true;
              setTimeout(() => {
                this.isPickupVideo = false;
              }, 5000);
            }
            this.setVideoCurrentTime(seekTime);
          }
        } else {
          endTime = this.isWarnPreview
            ? localStorage.getItem(localStorage.getItem('warm_recordId'))
            : localStorage.getItem(this.vodOption.recordId);
          const parsedEndTime = parseInt(endTime);
          if (endTime && endTime != 'undefined' && parsedTotalTime != parsedEndTime) {
            const seekTime = endTime < 6 ? 0 : endTime - 5;
            this.setVideoCurrentTime(seekTime);
          }
        }
      },
      showLabelFun(eventTime) {
        this.sliderVal = (eventTime / this.totalTime) * 100;
        this.playerServer.setCurrentTime(eventTime, () => {
          this.$vhMessage.error(this.$t('host.k_510001'));
        });
        this.playerServer.play();
      },
      // 静音开关切换
      handleSwitchMuted() {
        this.playerServer.setMute(!this.playerState.isMuted);
      },
      // video自身 画中画功能
      openPIP() {
        if (document.pictureInPictureElement) {
          document.exitPictureInPicture();
        } else {
          if (document.pictureInPictureEnabled) {
            const players = this.playerServer?.playerInstance?.vhallplayer.getVideo();
            players.requestPictureInPicture();
          }
        }
      },
      // doc 画中画 可以存放非video 兼容性较差
      async openPIP2() {
        console.log('-----画中画-----');
        const player = document.querySelector('#vmp-player');

        // 打开一个画中画窗口。
        const pipWindow = await window.documentPictureInPicture.requestWindow({
          width: player.clientWidth / 2,
          height: player.clientHeight / 2
        });

        // 从初始文档中复制样式表，以使播放器外观相同。
        const allCSS = [...document.styleSheets]
          .map(styleSheet => {
            try {
              return [...styleSheet.cssRules].map(r => r.cssText).join('');
            } catch (e) {
              console.log('catch copy css ------>', e);
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.type = styleSheet.type;
              link.media = styleSheet.media;
              link.href = styleSheet.href;
              pipWindow.document.head.appendChild(link);
            }
          })
          .filter(Boolean)
          .join('\n');
        const style = document.createElement('style');
        style.textContent = allCSS;
        pipWindow.document.head.appendChild(style);

        pipWindow.document.body.style.border = 'none';

        const div = document.createElement('div');
        div.className = 'kkk';
        div.append(player);
        // 将播放器移动到画中画窗口中。
        pipWindow.document.body.append(div);

        // 当画中画窗口关闭时，将播放器移回原位置。
        pipWindow.addEventListener('pagehide', event => {
          const playerContainer = document.querySelector('.vmp-player');
          // const pipPlayer = event.target.querySelector('#player');
          playerContainer.prepend(player);
        });
      },
      openPipStatus() {
        this.pipIsOpen = true;

        //嵌入页
        if (window.self !== window.top) {
          window.top.postMessage(
            {
              type: 'vhEnterPictureInPicture',
              data: {
                webinar_id: this.roomBaseServer.state.watchInitData.webinar.id
              }
            },
            '*'
          );
        }
        // console.log('---openPipStatus-----');
      },
      closePipStatus() {
        this.pipIsOpen = false;

        // 嵌入页
        if (window.self !== window.top) {
          window.top.postMessage(
            {
              type: 'vhExitPictureInPicture',
              data: {
                webinar_id: this.roomBaseServer.state.watchInitData.webinar.id
              }
            },
            '*'
          );
        }
        // console.log('---closePipStatus-----');
      },
      // 获取点播字幕开关状态等配置, 默认开
      async getVodSubtitlesConfig() {
        if (this.aiSubtitleSwitch === -1 || !this.aiSubtitleStyle) {
          await this.aiServer.getAiVideoUnionInfo();
        }
      },
      showPlaybackExpiredMsg() {
        this.dialogVideoExpiredVisible = true;
        // this.$message({
        //   message: this.$tec(512912),
        //   showClose: true,
        //   // duration: 0,
        //   type: 'warning',
        //   customClass: 'zdy-info-box'
        // });
      }
    }
  };
</script>
<style lang="less">
  .vmp-player {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: #1a1a1a;
    z-index: 2;
    .delay_tips {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      line-height: 24px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 14px;
      padding: 5px 16px;
      z-index: 1000;
      border-radius: 30px;
      white-space: nowrap;
    }
    .webinar-disable {
      background: rgba(0, 0, 0);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 100;
      color: #fff;
    }
    &-watch {
      height: 100%;
      width: 100%;
      border-radius: 4px;
    }
    #vh-watermark-container {
      width: 90px;
      height: 30px;
      z-index: 1;
      img {
        width: 100% !important;
        height: 100% !important;
        object-fit: scale-down !important;
      }
    }
    #vhy-danmaku-wrapbox {
      z-index: 1;
    }
    .vhallPlayer-container {
      display: none !important;
    }
    &-living {
      &-background {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #1a1a1a;
        z-index: 8;
      }
      &-btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 8;
        div {
          background: rgba(0, 0, 0, 0.4);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          i {
            color: #e6e6e6;
            opacity: 1;
          }
        }
        &-normal {
          width: 88px;
          height: 88px;

          i {
            font-size: 34px;
          }
        }
        &-mini {
          width: 50px;
          height: 50px;
          i {
            font-size: 18px;
          }
        }
      }
      &-play {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        display: flex;
        // align-items: center;
        justify-content: center;
        z-index: 8;
        div {
          margin-top: 28vh;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          i {
            color: #e6e6e6;
            opacity: 1;
          }
        }
        &-normal {
          width: 72px;
          height: 72px;

          i {
            font-size: 34px;
          }
        }
      }
      &-end {
        z-index: 9;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &-img {
          width: 164px;
          height: 120px;

          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        &-mini {
          width: 120px;
          height: 80px;

          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }

        h1 {
          font-size: 16px;
          line-height: 50px;
          height: 50px;
          color: #999;
          padding-left: 38px;
          font-weight: 400;
        }
      }
      &-vodend {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        background-size: cover;
        z-index: 9;
        > div {
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          width: 100%;
        }
        &-try {
          height: 100%;
          h3 {
            color: #999;
            font-size: 16px;
            line-height: 30px;
            font-weight: normal;
          }
          .replay-try {
            margin-top: 30px;
            color: #fff;
            cursor: pointer;
            b {
              font-weight: normal;
              margin-left: 5px;
            }
          }
          span {
            margin-top: 5px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            border-radius: 20px;
            background: #fb3a32;
            display: inline-block;
            height: 40px;
            padding: 0 10px;
            line-height: 40px;
          }
          p {
            span {
              width: 90px;
              height: 40px;
              line-height: 40px;
            }
          }
        }
        &-isNoTry {
          &-refresh {
            background: rgba(0, 0, 0, 0.4);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            i {
              color: #e6e6e6;
              opacity: 1;
            }
          }
          span {
            margin-top: 5px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            border-radius: 20px;
            background: var(--theme-color-main);
            display: inline-block;
            &.repay--normal {
              padding: 0 20px;
              height: 40px;
              line-height: 40px;
              margin: auto 10px;
            }
            &.repay--mini {
              width: 90px;
              height: 30px;
              font-size: 12px;
              line-height: 30px;
              margin: auto 3px;
            }
          }
        }
        &-normal {
          width: 88px;
          height: 88px;
          margin-bottom: 10px;
          i {
            font-size: 34px;
          }
        }
        &-mini {
          width: 50px;
          height: 50px;
          margin-bottom: 3px;
          i {
            font-size: 18px;
          }
        }
      }
      &-audio {
        z-index: 1;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url('../src/img/video.gif');
        background-size: 100% 100%;
        div {
          text-align: center;
          color: @font-error-low;
          font-size: 16px;
          margin-top: 42%;
        }
      }
      &-exchange {
        position: absolute;
        top: 10px;
        z-index: 9;
        right: 8px;
        width: 32px;
        height: 32px;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 50%;
        cursor: pointer;
        p {
          text-align: center;
        }
        span {
          display: inline-block;
          text-align: right;
          font-size: 14px;
        }
        i {
          font-size: 16px;
          color: #e6e6e6;
          opacity: 1;
          cursor: pointer;
          &:hover {
            color: var(--theme-color-main);
          }
        }
      }
    }
    &-controller {
      position: absolute;
      // bottom: 0;
      bottom: -48px;
      z-index: 8;
      width: 100%;
      height: 38px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.7);
      transition: all 0.8s;
      &.active-control {
        bottom: 0px;
      }
      &.previre-control {
        bottom: 0px;
      }
      .controller_slider {
        position: absolute;
        top: -4px;
        width: 100%;
        left: 0;
        .vh-slider__runway {
          margin: 0;
          height: 4px;
          background-color: rgba(255, 255, 255, 0.3);
        }
        .vh-slider__bar {
          height: 4px;
          background-color: var(--theme-color-main);
        }
        .vh-slider__button {
          width: 9px;
          height: 9px;
          border: 0;
          position: absolute;
          top: 13px;
          left: 16px;
          background-color: var(--theme-color-main);
          box-shadow: 0 0 10px var(--theme-color-main);
        }
        &:hover {
          // .vh-slider__bar {
          //   height: 9px;
          // }
          // .vh-slider__runway {
          //   background: transparent;
          // }
          .vh-slider__button {
            width: 13px;
            height: 13px;
            top: 11px;
            transform: scale(1) !important;
          }
        }
      }
      .controller-tools {
        height: 38px;
        display: flex;
        // line-height: 38px;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .vh-iconfont {
          font-size: 20px;
          color: @font-error-low;
          cursor: pointer;
          &:hover {
            color: @font-error-low;
          }
        }
        &-left {
          padding-left: 20px;
          display: flex;
          color: @font-error-low;
          align-items: center;
          > div {
            padding-right: 5px;
          }
          &-time {
            color: @font-error-low;
            &-current {
              display: inline-block;
              min-width: 40px;
              height: 40px;
              max-width: 56px;
              line-height: 40px;
            }
            &-total {
              color: @font-light-low;
            }
          }
          .controller-tools-left-start {
            position: relative;
            top: -2px;
          }
        }
        &-right {
          display: flex;
          z-index: 1002;
          > div {
            padding-right: 20px;
            position: relative;
            color: @font-error-low;
          }
          .vh-iconfont {
            font-size: 18px;
            &:hover {
              color: var(--theme-color-main);
            }
          }
          span {
            &:hover {
              cursor: pointer;
              color: var(--theme-color-main);
            }
          }
          &-lang,
          &-quality,
          &-speed {
            &:hover {
              .controller-tools-right-list {
                display: block;
              }
            }
          }
          &-list {
            list-style: none;
            position: absolute;
            bottom: 100%;
            left: -45%;
            width: 70px;
            // padding: 10px 0;
            // background-color: rgba(0, 0, 0, 0.7);
            // border-radius: 4px;
            // line-height: 30px;
            display: none;
            padding-bottom: 20px;
            .content_base {
              padding: 10px 0;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 4px;
              line-height: 30px;
            }
            li {
              text-align: center;
              cursor: pointer;
              &:hover {
                color: var(--theme-color-main);
              }
            }
            .vmp-player-li-active {
              color: var(--theme-color-main);
            }
            &.controller-lang {
              left: -16%;
            }
          }
          &-volume {
            position: relative;
            cursor: pointer;
            &:hover {
              .controller-tools-right-volume-slider {
                display: block;
              }
            }
            &-slider {
              width: 30px;
              position: absolute;
              bottom: 100%;
              left: -20%;
              // background-color: rgba(0, 0, 0, 0.7);
              display: none;
              // border-radius: 4px;
              padding-bottom: 20px;
              .volume-slider_base {
                background-color: rgba(0, 0, 0, 0.7);
                border-radius: 4px;
              }
              .is-vertical .vh-slider__runway {
                margin: 10px auto 10px;
                background-color: rgba(255, 255, 255, 0.3);
              }
              .vh-slider__bar {
                background-color: var(--theme-color-main);
              }
              .vh-slider__button {
                position: absolute;
                width: 12px;
                height: 12px;
                top: 10px;
                left: 12px;
                border: 0;
                background-color: var(--theme-color-main);
                box-shadow: 0 0 10px var(--theme-color-main);
              }
            }
          }
        }
      }
    }
    &-controllerMini {
      position: absolute;
      bottom: -48px;
      z-index: 8;
      width: 100%;
      height: 38px;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.7);
      transition: all 0.8s;
      &.active-control {
        bottom: 0px;
      }
      &.previre-control {
        bottom: 0px;
      }
      .controller_slider {
        position: absolute;
        top: -4px;
        width: 100%;
        left: 0;
        .vh-slider__runway {
          margin: 0;
          height: 2px;
          background-color: rgba(255, 255, 255, 0.3);
        }
        .vh-slider__bar {
          height: 2px;
          background-color: var(--theme-color-main);
        }
        .vh-slider__button {
          width: 5px;
          height: 5px;
          border: 0;
          position: absolute;
          top: 13px;
          left: 16px;
          background-color: var(--theme-color-main);
          box-shadow: 0 0 10px var(--theme-color-main);
        }
        &:hover {
          // .vh-slider__runway,
          // .vh-slider__bar {
          //   height: 5px;
          // }
          .vh-slider__button {
            width: 10px;
            height: 10px;
            // top: -2px;
            transform: scale(1) !important;
          }
        }
      }
      .controller-tools {
        height: 38px;
        display: flex;
        // line-height: 38px;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        .vh-iconfont {
          font-size: 14px;
          color: @font-error-low;
          cursor: pointer;
          &:hover {
            color: @font-error-low;
          }
        }
        &-left {
          padding-left: 12px;
          display: flex;
          color: @font-error-low;
          align-items: center;
          > div {
            padding-right: 5px;
          }
          &-time {
            color: @font-error-low;
            &-current {
              display: inline-block;
              min-width: 40px;
              height: 40px;
              max-width: 56px;
              line-height: 40px;
              font-size: 12px;
            }
            &-total {
              color: @font-light-low;
              font-size: 12px;
            }
          }
          .controller-tools-left-start {
            position: relative;
            top: -2px;
          }
        }
        &-right {
          display: flex;
          z-index: 1002;
          > div {
            padding-right: 12px;
            position: relative;
            color: @font-error-low;
            font-size: 12px;
          }
          .vh-iconfont {
            font-size: 14px;
            &:hover {
              color: var(--theme-color-main);
            }
          }
          span {
            &:hover {
              cursor: pointer;
              color: var(--theme-color-main);
            }
          }
          &-quality,
          &-speed {
            &:hover {
              .controller-tools-right-list {
                display: block;
              }
            }
          }
          &-list {
            list-style: none;
            position: absolute;
            bottom: 100%;
            left: -45%;
            width: 55px;
            // padding: 5px 0;
            // background-color: rgba(0, 0, 0, 0.7);
            // border-radius: 4px;
            // line-height: 25px;
            font-size: 12px;
            display: none;
            padding-bottom: 20px;
            .content_base {
              padding: 5px 0;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 4px;
              line-height: 25px;
            }
            li {
              text-align: center;
              cursor: pointer;
              &:hover {
                color: var(--theme-color-main);
              }
            }
            .vmp-player-li-active {
              color: var(--theme-color-main);
            }
          }
          &-volume {
            position: relative;
            cursor: pointer;
            &:hover {
              .controller-tools-right-volume-slider {
                display: block;
              }
            }
            &-slider {
              width: 30px;
              position: absolute;
              bottom: 100%;
              left: -20%;
              // background-color: rgba(0, 0, 0, 0.7);
              display: none;
              // border-radius: 4px;
              padding-bottom: 20px;
              .volume-slider_base {
                background-color: rgba(0, 0, 0, 0.7);
                border-radius: 4px;
              }
              .is-vertical .vh-slider__runway {
                margin: 10px auto 10px;
                width: 4px;
                background-color: rgba(255, 255, 255, 0.3);
              }
              .vh-slider__bar {
                width: 4px;
                background-color: var(--theme-color-main);
              }
              .vh-slider__button {
                position: absolute;
                width: 8px;
                height: 8px;
                top: 10px;
                left: 13px;
                border: 0;
                background-color: var(--theme-color-main);
                box-shadow: 0 0 10px var(--theme-color-main);
              }
            }
          }
        }
      }
    }
    &-tips {
      z-index: 5;
      &-box {
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        color: #f7f7f7;
        background: @bg-dark-normal;
        border-radius: 20px;
        position: absolute;
        bottom: 60px;
        left: 45%;
        z-index: 6;
        > div {
          padding: 0 16px;
        }
        span {
          color: var(--theme-color-main);
        }
      }
      &-prew {
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        color: #f7f7f7;
        background: @bg-dark-normal;
        border-radius: 20px;
        position: absolute;
        bottom: 60px;
        left: 10px;
        z-index: 6;
        > div {
          padding: 0 12px;
        }
        b {
          font-weight: normal;
          color: var(--theme-color-main);
          padding: 5px;
        }
        .red {
          color: var(--theme-color-main);
          padding: 0 3px;
        }
        i {
          font-style: normal;
        }
        span {
          color: #f7f7f7;
          cursor: pointer;
        }
        .vh-iconfont {
          font-size: 14px;
          padding-left: 12px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }

  // 作为观看端时的样式
  .vmp-player.is-watch {
    // 普通模式
    &.vmp-player--normal {
      position: absolute;
      top: 0;
      bottom: 56px;
      width: calc(100% - 380px);
      height: auto;
      min-height: auto;
      &.vmp-player-embed {
        width: 100%;
        height: 100%;
      }
      &.vmp-player-embedFull {
        width: calc(100% - 360px);
      }
    }

    &.vmp-player--mini {
      position: absolute;
      width: 360px;
      height: 204px;
      min-height: 204px;
      top: 0;
      right: 0;
      z-index: 10;
      &.is-hide-right-menu {
        display: none;
      }

      .vmp-order-rank {
        display: none;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .vmp-player {
      .vmp-player-living-play {
        .vmp-player-living-play-normal {
          width: 50px;
          height: 50px;
          i {
            font-size: 18px;
          }
        }
      }
    }
  }

  .danmaku-setting-popover {
    margin-bottom: 20px !important;
    padding: 0;
    background: transparent;
  }

  // 解决报错：Blocked aria-hidden on an element because its descendant retained focus. The focus must not be hidden ...
  .vh-popover[aria-hidden='true'] {
    display: none !important;
  }
</style>
